'use strict'

const campaignsEndpoint = '/cmsapi/v1/campaigns/'
const industryQuery = '?industry='

export async function getCampaignsByIndustry(industry) {
  return new Promise((res, rej) => {
    const url = `${campaignsEndpoint}${industryQuery}${industry}`
    const xhr = new XMLHttpRequest()
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        res(JSON.parse(xhr.response))
      }
    }

    xhr.addEventListener('error', err => rej(err))
    xhr.open('GET', url, true)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send()
  })
}
